import { loadComponents } from "./component_loader";

document.addEventListener("DOMContentLoaded", () => {
  loadComponents();
});
